const RemoveAllCartItems = (cartlist, removeFromCart) => {
  cartlist.forEach((item) => {
    removeFromCart(item.id);
  });
  //   try {
  //     return { valid: true, message: "" };
  //   } catch (error) {
  //     //  is invalid
  //     return { valid: false, message: "" };
  //   }
};

export default RemoveAllCartItems;
